// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectTenureQueryResult, selectTenurePageLoading, selectTenureShowInitWaitingMessage} from '../_selectors/tenure.selectors';

export class TenureDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectTenurePageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectTenureShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectTenureQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
